<template>
  <div class="w-[50px] h-[70px] flex items-center">
    <input
      ref="input"
      v-model="model"
      :type="inputType"
      :inputmode="inputMode"
      min="0"
      max="9"
      maxlength="1"
      pattern="[0-9]"
      class="h-full w-full rounded-2xl text-center text-gray-900 text-[36px] font-bold border border-gray-300 outline outline-2 outline-transparent"
      :class="[
        'border p-2',
        { '!outline-dark': input.isFocused },
        inputClasses
      ]"
      @input="handleOnChange"
      @keydown="handleOnKeyDown"
      @paste="handleOnPaste"
      @focus="handleOnFocus"
      @blur="handleOnBlur"
    />
    <span v-if="!isLastChild && separator" class="ml-2">
      <span v-html="separator"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseOptInputSingle',

  props: {
    value: { type: String },
    separator: { type: String },
    focus: { type: Boolean },
    inputClasses: { type: String },
    shouldAutoFocus: { type: Boolean },
    inputType: { type: String, default: 'text' },
    inputMode: { type: String, default: 'numeric' },
    isLastChild: { type: Boolean }
  },
  data() {
    return {
      model: this.value || '',

      input: {
        isFocused: false
      }
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.model = newValue
      }
    },
    focus(newFocusValue, oldFocusValue) {
      if (oldFocusValue !== newFocusValue && this.$refs.input && this.focus) {
        this.$refs.input.focus()
        this.$refs.input.select()
      }
    }
  },
  mounted() {
    if (this.$refs.input && this.focus && this.shouldAutoFocus) {
      this.$refs.input.focus()
    }
  },
  methods: {
    handleOnChange() {
      if (this.model.length > 1) {
        this.model = this.model.slice(0, 1)
      }
      return this.$emit('on-change', this.model)
    },
    handleOnKeyDown(event) {
      const keyEvent = event || window.event
      const charCode = keyEvent.which ? keyEvent.which : keyEvent.keyCode
      if (
        this.isCodeNumeric(charCode) ||
        [8, 9, 13, 37, 39, 46, 86].includes(charCode)
      ) {
        this.$emit('on-keydown', event)
      } else {
        keyEvent.preventDefault()
      }
    },
    isCodeNumeric(charCode) {
      return (
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 96 && charCode <= 105)
      )
    },
    handleOnPaste(event) {
      return this.$emit('on-paste', event)
    },
    handleOnFocus() {
      this.input.isFocused = true
      this.$refs.input.select()
      return this.$emit('on-focus')
    },
    handleOnBlur() {
      this.input.isFocused = false
      return this.$emit('on-blur')
    }
  }
}
</script>
